import { useEffect } from 'react';
import { Router } from './router';
import { useAuthStore } from './stores/authStore';

/**
 * Main app component - loads user on mount and renders router.
 * OAuth Hub listener is registered at module level in authStore.ts to avoid
 * a race condition where the signInWithRedirect event fires before React mounts.
 */
function App() {
  const { loadUser } = useAuthStore();

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return <Router />;
}

export default App;
